import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { IBoxxGenericFormEmitter } from '@boxx/core';
import {
  CategoryModel,
  ProductModel,
  StorePageStore,
  VariationModel,
} from '@boxx/store-core';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as moment from 'moment';
import { OnboardingStore } from '@boxx/onboarding-core/lib/state/onboarding.store';
import { DatetimePickerComponent } from '@boxx/shared-components/lib/datetime-picker/datetime-picker.component';
import { BoxxUtilsService } from 'src/services/BoxxUtils.service';
import { ProductListCouponsPage } from '@app/pages/store/components/coupons/product-list/product-list.page';
import { CategoriesListCouponPage } from '@app/pages/store/components/coupons/categories-list/categories-list.page';

@Component({
  selector: 'boxx-coupon-form',
  templateUrl: './coupon-form.component.html',
  styleUrls: ['./coupon-form.component.scss'],
})
export class CouponFormComponent implements OnInit, OnDestroy {

  @Input() coupon;
  @Output() boxxChange = new EventEmitter<IStoreCouponFormEmitter>();

  destroyed$ = new Subject<boolean>();
  couponForm: FormGroup;
  hasOptions = false;
  productOptions: any[];
  selectedImages: { [key: number]: string } = {};

  categoryStoreList: CategoryModel[] = [];
  productStoreList: ProductModel[] = [];
  loadingCategories = false;

  variationList: VariationModel[] = [];
  loadingVariations = false;

  private originalValues: any;

  private translations: any;

  daySel: any;
  productsList: any[];
  categoriesList: any[];
  maxDate: string;

  public languageCode: string = 'es';
  constructor(
    private storePageStore: StorePageStore,
    private fb: FormBuilder,
    private viewCrtl: ModalController,
    public translate: TranslateService,
    private onboardingStore: OnboardingStore,
    private boxxUtils: BoxxUtilsService
  ) {
    translate
    .get(['BUSINESS_FORMS', 'STORE_MODULE', 'IMAGES_MODULE', 'ACTIONS', 'ERRORS', 'SUCCESS'])
      .pipe(takeUntil(this.destroyed$))
      .subscribe((t) => (this.translations = t));
  }

  ngOnInit() {
    this.storePageStore.categoriesStore.data$
      .pipe(takeUntil(this.destroyed$))
      .subscribe((categoryList) => {
        this.categoryStoreList = categoryList;
    });

    this.storePageStore.productsStore.data$
    .pipe(takeUntil(this.destroyed$))
    .subscribe((productList) => {
      this.productStoreList = productList;
    });

    this.maxDate = (Number(new Date().getFullYear())+1) + '-12-31';
    this.onboardingStore.businessConfig.businessData$
    .pipe(takeUntil(this.destroyed$))
    .subscribe((business) => {
      if (!business) {
        return;
      }
      this.languageCode = (business.languageCode !== undefined || business.languageCode !== '') ? business.languageCode : '';
      this.initForm();
    });
    if(this.coupon !== undefined){
      this.patchForm(this.coupon);
    }
   //this.loadCategories();
    this.handleLoading();
  }

  patchForm(coupon: any) {
    this.couponForm.patchValue({
     
      id: coupon.id,
      name: coupon.name,
      code: coupon.code,
      discountType: coupon.discountType,
      status: coupon.status,
      discount: coupon.discount,
      launchDate: this.formatDate(coupon.launchDate),
      expirationDate: (coupon.expirationDate !== undefined) ? this.formatDate(coupon.expirationDate) : this.formatDate(coupon.launchDate),
      usesLimit: coupon.usesLimit,
      applicationLimit: coupon.applicationLimit,
      orderCount: coupon.orderCount,
      totalLimit: coupon.totalLimit,

    });

    setTimeout(() => {
      if(coupon.catalogLimit && coupon.catalogLimit.categories !== undefined && coupon.catalogLimit.categories.length > 0){
        this.categoriesList = [];
        for(let i = 0; i < coupon.catalogLimit.categories.length; i++){

          const itemCat = this.categoryStoreList.filter((item)=> item.id === coupon.catalogLimit.categories[i]);
          if(itemCat && itemCat !== null){
            this.categoriesList.push({
              id: itemCat[0].id,
              name: itemCat[0].name,
              description: itemCat[0].description,
              productCount: itemCat[0].productCount,
              image: itemCat[0].image,
              checked: true
            });
          }
        }
        this.couponForm.patchValue({
          categoriesList: this.categoriesList
        });
      }

      if(coupon.catalogLimit && coupon.catalogLimit.products !== undefined && coupon.catalogLimit.products.length > 0){
        this.productsList = [];
        for(let i = 0; i < coupon.catalogLimit.products.length; i++){

          const itemProd = this.productStoreList.filter((item)=> item.id === coupon.catalogLimit.products[i]);
          if(itemProd && itemProd !== null){
            this.productsList.push({
              id: itemProd[0].id,
              enabled: itemProd[0].enabled,
              name: itemProd[0].name,
              price: itemProd[0].price,
              unlimited: itemProd[0].unlimited,
              quantity: itemProd[0].quantity,
              media: itemProd[0].media,
              checked: true
            });
          }
        }
        this.couponForm.patchValue({
          productsList: this.productsList
        });
      }
    }, 200);
    this.originalValues = this.couponForm.value;
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  initForm() {
    this.daySel = moment(new Date());
    this.couponForm = this.fb.group({
      id: [''],
      name: ['', Validators.required],
      code: ['', Validators.required],
      discountType: ['ABS', Validators.required],
      status: ['ACTIVE', Validators.required],
      discount: [0, Validators.required],
      launchDate: [this.formatDate(this.daySel), Validators.required],
      expirationDate: [this.formatDate(this.daySel), Validators.required],
      usesLimit: ['UNLIMITED', Validators.required],
      applicationLimit: ['UNLIMITED', Validators.required],
      orderCount: [0, Validators.required],
      totalLimit: [0],
      categoriesList: [[]],
      productsList: [[]]
    });
    this.originalValues = { ...this.couponForm.value };
  }

  formatMonthSelected(month: string){
    let monthNumber;
    switch (month) {
      case 'Ene':
      case 'Jan':
        monthNumber = '01';
        break;
      case 'Feb':
        monthNumber = '02';
        break;  
      case 'Mar':
        monthNumber = '03';
        break;  
      case 'Abr':
      case 'Apr':
        monthNumber = '04';
        break; 
      case 'May':
        monthNumber = '05';
        break;   
      case 'Jun':
        monthNumber = '06';
        break;  
      case 'Jul':
        monthNumber = '07';
        break;  
      case 'Ago':
      case 'Aug':
        monthNumber = '08';
        break; 
      case 'Sep':
        monthNumber = '09';
        break;  
      case 'Oct':
        monthNumber = '10';
        break;
      case 'Nov':
        monthNumber = '11';
        break;
      case 'Dic':
      case 'Dec':
        monthNumber = '12';
        break;
      default:
        break;
    }
    return monthNumber;
  }

  formatMonthNumber(month: string){
    var monthNames = this.languageCode === 'es' ?
    ["Ene", "Feb", "Mar", "Abr", "May", "Jun",
                      "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"]
    :
    ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
                      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    return monthNames[Number(month)-1];
  }

  async pickerDatetime(typeInput: Number){
    const ctrls = this.couponForm.value;
    const dateSplit = ((typeInput === 1) ? ctrls.launchDate : ctrls.expirationDate).split(' ');
    const dateFormat = dateSplit[2] + '-' + this.formatMonthSelected(dateSplit[1]) + '-' + ((dateSplit[0].length < 2) ? '0'+dateSplit[0] : dateSplit[0]) + 'T01:01:01-01:00';
    const view = await this.viewCrtl.create({
      component: DatetimePickerComponent,
      componentProps: {
        customDate: dateFormat,
        customPres: 'date'
      }
    });

    await view.present();

    const { data } = await view.onWillDismiss();

    if (data) {
        if(typeInput === 1){
          const dateSplit = data.cDate.split('T');
          const dateFormat = dateSplit[0].split('-');
          const dateFinal = dateFormat[2] + ' ' + this.formatMonthNumber(dateFormat[1]) + ' ' + dateFormat[0];
          this.couponForm.patchValue( { 
            launchDate: dateFinal,
            expirationDate: dateFinal
          });
        }
        else{
          const formVal = this.couponForm.value;
          const dateStartSplit = formVal.launchDate.split(' ');
          const dateStartFormat = dateStartSplit[2] + '-' + this.formatMonthSelected(dateStartSplit[1]) + '-' + dateStartSplit[0] 
          
          const dateSplit = data.cDate.split('T');
          const dateEndFormat = dateSplit[0].split('-');
          const dateFinal = dateEndFormat[2] + ' ' + this.formatMonthNumber(dateEndFormat[1]) + ' ' + dateEndFormat[0];
          
          if(new Date(dateSplit[0]) < new Date(dateStartFormat)){
            this.boxxUtils.showToastError({
              message: this.translations.STORE_MODULE.couponsItem_VIEW.couponForm.dateErrorMessage
            });
          }
          else{
            this.couponForm.patchValue( { 
              expirationDate: dateFinal
            });
          }
        }
        this.onFieldChange();
    }
  }

  async confirmDeleteCategory(id: number) {

    this.categoriesList.splice(id, 1);
    this.couponForm.patchValue( { 
      categoriesList: this.categoriesList
    });
    this.onFieldChange();
  }

  async confirmDeleteProduct(id: number) {

    this.productsList.splice(id, 1);
    this.couponForm.patchValue( { 
      productsList: this.productsList
    });
    this.onFieldChange();
  }

  formatDate(d){
    var monthNames = this.languageCode === 'es' ?
    ["Ene", "Feb", "Mar", "Abr", "May", "Jun",
                      "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"]
    :
    ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
                      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    var t = moment(d).format('YYYY-MM-DD'); //new Date(d);
    //return t.format('D')
    //return t.getDate()+' '+monthNames[t.getMonth()]+' '+t.getFullYear();

    var check = moment(d, 'YYYY/MM/DD');
    var month = check.format('M');
    var day   = check.format('D');
    var year  = check.format('YYYY');
    return day + ' ' + monthNames[Number(month)-1] + ' ' + year;
  }

  async openProductsModal() {
    const modal = await this.viewCrtl.create({
      component: ProductListCouponsPage,
      componentProps: {
        previousProductOptions: this.productsList ? this.productsList : [],
      },
    });

    modal.present();

    const { data } = await modal.onWillDismiss();
    if (data) {
      this.productsList = [];
      this.productsList = data.data;
      this.couponForm.patchValue( { 
        productsList: data.data
      });
      this.onFieldChange();
    }
  }

  async openCatModal () {
    const modal = await this.viewCrtl.create({
      component: CategoriesListCouponPage,
      componentProps: {
        previousCategoriesOptions: this.categoriesList ? this.categoriesList : [],
      },
    });

    modal.present();

    const { data } = await modal.onWillDismiss();
    if (data) {
      this.categoriesList = [];
      this.categoriesList = data.data;
      this.couponForm.patchValue( { 
        categoriesList: data.data
      });
      this.onFieldChange();
    }
  }

  getFirstLetter(name){
    return name.charAt(0).toUpperCase();
  }

  onFieldChange() {
    const values = this.couponForm.value;

    if(values.code){
      this.couponForm.patchValue( { 
        code: values.code.toUpperCase()
      });
    }

    const hasChanges = Object.keys(values).some((key) => {
      const originalValue = this.originalValues[key];
      const newValue = this.couponForm.get(key).value;

      if (['categories', 'options'].includes(key)) {
        const valueHasChanges =
          newValue.length !== (originalValue || []).length ||
          !(originalValue || []).every((val: number) => newValue.includes(val));

        return valueHasChanges;
      }

      return newValue !== originalValue;
    });

    this.boxxChange.emit({
      hasChanges,
      data: values,
      valid: this.couponForm.valid,
    });
  }

  private handleLoading() {
    this.storePageStore.categoriesStore.loading$
      .pipe(takeUntil(this.destroyed$))
      .subscribe((loading) => {
      });
  }

}

export type IStoreCouponFormEmitter = IBoxxGenericFormEmitter<any>;
